<ng-template #loading>
  <div class="container">
    <div>
      <br/>
      Loading...
      <mat-progress-bar class="progress" mode="indeterminate"></mat-progress-bar>
    </div>
  </div>
</ng-template>

<div *ngIf="councilGradingStats != null; else loading">
  <span class="mat-body-strong">State Summary</span>
  <br/><br/>
  <div>
    <strong>Councils submitting at least 1 activity: </strong> {{numParticipatingCouncils}} / {{totalCouncils}} ({{councilParticipationPercentage | percent: '1.0-2'}})
  </div>
  <br/>
  <div class="mat-elevation-z6">
    <table mat-table matSort [dataSource]="datasource" matSortActive="councilTotal" matSortDirection="desc">

      <ng-container matColumnDef="councilId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Council</th>
        <td mat-cell *matCellDef="let council">{{council.councilId}}</td>
      </ng-container>

      <ng-container matColumnDef="diocese">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Diocese</th>
        <td mat-cell *matCellDef="let council">{{council.diocese}}</td>
      </ng-container>

      <ng-container matColumnDef="division">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Division</th>
        <td mat-cell *matCellDef="let council">{{council.division}}</td>
      </ng-container>

      <ng-container matColumnDef="faithTotal">
        <th mat-header-cell *matHeaderCellDef>Faith</th>
        <td mat-cell *matCellDef="let council">{{council.faithTotal}}</td>
      </ng-container>

      <ng-container matColumnDef="familyTotal">
        <th mat-header-cell *matHeaderCellDef>Family</th>
        <td mat-cell *matCellDef="let council">{{council.familyTotal}}</td>
      </ng-container>

      <ng-container matColumnDef="communityTotal">
        <th mat-header-cell *matHeaderCellDef>Community</th>
        <td mat-cell *matCellDef="let council">{{council.communityTotal}}</td>
      </ng-container>

      <ng-container matColumnDef="lifeTotal">
        <th mat-header-cell *matHeaderCellDef>Life</th>
        <td mat-cell *matCellDef="let council">{{council.lifeTotal}}</td>
      </ng-container>

      <ng-container matColumnDef="membershipTotal">
        <th mat-header-cell *matHeaderCellDef>Membership</th>
        <td mat-cell *matCellDef="let council">{{council.membershipTotal}}</td>
      </ng-container>

      <ng-container matColumnDef="councilTotal">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Points</th>
        <td mat-cell *matCellDef="let council">{{council.councilTotal}}</td>
      </ng-container>

      <tr class="summary-header-row" mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr class="summary-row" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>
